import React from 'react';
import styled from 'styled-components';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { ModalSliceType, openModal } from '../../../redux/slices/modal';
import { selectOpenedModalType } from '../../../redux/selectors/modal';
import ReportSearchModal from '../../../components/ReportSearchModal';
import { level1Content } from '../../../styles/shareableStyles';
import { SecondaryButton } from '../../../components/Button';
import { SvgIcon } from '../../../components/Icon';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  ${level1Content};
`;

const FavoritedReportsEmptySlide = () => {
  const dispatch = useAppDispatch();

  const isAddExistingReportsOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.ReportsSearch, 'favorites'),
  );

  const handleClick = () => {
    dispatch(
      openModal({
        type: ModalSliceType.ReportsSearch,
        data: null,
        id: 'favorites',
      }),
    );
  };

  return (
    <>
      <Container>
        <SecondaryButton size="default" onClick={handleClick} isOutlined={true}>
          <SvgIcon
            name="star"
            width={24}
            height={24}
            customFill="currentColor"
          />
          Favorite a Report
        </SecondaryButton>
      </Container>
      {isAddExistingReportsOpen && <ReportSearchModal type="open-report" />}
    </>
  );
};

export default FavoritedReportsEmptySlide;
